module.exports = __webpack_public_path__ + "static/media/oxygene.f3b9571f.svg";